import { OnboardDeviceLogsUploadStatus } from '../interfaces';

export const ONBOARD_DEVICE_LOGS_SYNC_WS_EVENT_TYPE = 'onboard_device_logs_sync';

/**
 * Pick a logs sync snapshot out of the shared socket's traffic.
 *
 * Returns null for anything that is not one - the socket also carries device
 * online/offline events, and every client sees every frame.
 */
export const parseOnboardDeviceLogsSyncSnapshot = (data: string): OnboardDeviceLogsUploadStatus | null => {
    try {
        const parsedData: unknown = JSON.parse(data);

        if (!parsedData || typeof parsedData !== 'object') {
            return null;
        }

        const payload = parsedData as Partial<OnboardDeviceLogsUploadStatus> & { type?: string };

        if (payload.type !== ONBOARD_DEVICE_LOGS_SYNC_WS_EVENT_TYPE) {
            return null;
        }

        if (!payload.requestId || typeof payload.requestId !== 'string') {
            return null;
        }

        return payload as OnboardDeviceLogsUploadStatus;
    } catch (error) {
        return null;
    }
};
